export default __webpack_public_path__ + "static/media/parent_logout.b32e8f7a.svg";